import { Helmet } from 'react-helmet-async';
import { Redirect } from 'react-router-dom';

import DealerRequiredPageShell from 'app/components/ReusableUIComponents/HighLevelComponents/DealerRequiredPageShell';
import { DealerPageHeaderEntityInfo } from 'app/components/ReusableUIComponents/LowLevelComponents/PageHeaderEntityInfo';
import { withResourceProtection } from 'app/components/ReusableUIComponents/HOCs/ResourceProtected/withResourceProtection';
import { useV2DealerRequiredRedirect } from 'app/hooks/useV2DealerRequiredRedirect';
import { DealerLaunchSettingsComponent } from 'app/pages/DealerLaunchSettingsComponent/Loadable';
import { CONFIGURE_RESOURCE_LAUNCH_SETTINGS } from 'app/pages/ConfigurePage/utils/configureResourceIds';

import { useLaunchSettingsConfigurationPage } from './hooks/useLaunchSettingsConfigurationPage';

const LaunchSettingsConfigurationPage = () => {
  const { isBlocked } = useV2DealerRequiredRedirect();
  const { breadcrumbsList, hasDealer, dealerTitle, dealerId } =
    useLaunchSettingsConfigurationPage();

  if (isBlocked) {
    return <Redirect to="/configure" push={false} />;
  }

  return (
    <>
      <Helmet>
        <title>Launch settings</title>
        <meta
          name="description"
          content="Configure dealer launch settings for the selected dealership"
        />
      </Helmet>
      <DealerRequiredPageShell
        hasDealer={hasDealer}
        breadcrumbsList={breadcrumbsList}
        pageTitle="Dealer launch settings"
        headerSubtitle={
          hasDealer ? (
            <DealerPageHeaderEntityInfo
              title={dealerTitle}
              dealerId={dealerId}
            />
          ) : undefined
        }
        contentVariant="centered"
      >
        <DealerLaunchSettingsComponent defaultExpanded />
      </DealerRequiredPageShell>
    </>
  );
};

export default withResourceProtection(
  LaunchSettingsConfigurationPage,
  CONFIGURE_RESOURCE_LAUNCH_SETTINGS,
);
